import styled from 'styled-components';

const LayoutContainer = styled.div`
  padding-top: 68px;
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.lightGray};
  overflow: auto;
  min-width: fit-content;
`;

export const S = {
  LayoutContainer,
};
